<template>
  <div
    class="bg-surface rounded-lg p-8 flex flex-col-reverse md:flex-row gap-8"
  >
    <template v-if="props.nextContent">
      <div class="w-full md:w-2/3">
        <h1
          class="text-4xl text-on-background font-semibold line-clamp-3 md:line-clamp-1"
        >
          {{ hub.title }}
        </h1>
        <p
          class="text-sm text-on-background-variant line-clamp-10 md:line-clamp-3"
        >
          {{ props.hub.description }}
        </p>
        <div class="mt-12 mb-8 space-y-2">
          <p
            class="uppercase text-on-background-variant text-xs tracking-[5px]"
          >
            {{ t('hub-homepage.next-step') }}
          </p>
          <h2
            class="text-lg font-semibold text-on-background line-clamp-2 md:line-clamp-1"
          >
            {{ props.nextContent.title }}
          </h2>
          <p
            class="text-xs text-on-background-variant line-clamp-5 md:line-clamp-1"
          >
            {{ props.nextContent.description }}
          </p>
        </div>
        <Button
          :label="t('hub-homepage.complete-today-activity')"
          :to="`/${props.hub.slug}/${props.nextContent.slug}`"
        />
      </div>
      <div class="w-full md:w-1/3">
        <img
          :src="getOptimizedImgUrl(props.nextContent.imageUrl)"
          alt="Content preview image"
          class="rounded-md aspect-3/2 mx-auto object-cover"
        />
      </div>
    </template>
    <div v-else class="pb-8 w-full">
      <all-actions-completed-svg class="mx-auto" />
      <div class="font-semibold text-2xl mt-13 text-center">
        {{ t('hub-homepage.action-completed') }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ContentDto } from '~/api/contents';
import { HubDto } from '~/api/hubs';
import { Button } from '@exfluential/ui';
import imageProxyBuilder, { ResizeType } from '@bitpatty/imgproxy-url-builder';
import { useRuntimeConfig } from '#imports';
import AllActionsCompletedSvg from '@/assets/images/all-actions-completed.svg?component';

const config = useRuntimeConfig();

type Props = {
  hub: HubDto;
  nextContent?: ContentDto;
};
const props = defineProps<Props>();

const { t } = useI18n();

const getOptimizedImgUrl = (url: string): string =>
  imageProxyBuilder()
    .resize({ type: ResizeType.FILL_DOWN, width: 480, height: 320 })
    .format('webp')
    .build({
      baseUrl: config.public.imgProxyBaseUrl || '',
      path: url,
      addExtension: true,
    });
</script>
